<template>
    <div class="out">
        <div class="body_bg">
            <div class="topHead" v-if="title_name.is_codetimes == '0' || productInfo.image">
                <div class="top left"></div>
                <div class="top center">
                    <img :src="productInfo.image" style="width:90%;" />
                </div>
                <div class="top right">
                    <div class="rect" v-if="title_name.is_codetimes == '0'">
                        <span>{{ productInfo.inspect_num }}</span>
                        <span>扫码次数</span>
                    </div>
                </div>
            </div>
            <div class="tit">
                <span>{{ productInfo.store_name }}</span>
            </div>
            <div class="securityDetailTit" v-if="title_name.is_getrecord == '0'">
                <img src="@images/seach1.png" class="image" />
                <span class="headings">查询记录</span>
            </div>
            <div class="queryResults" v-if="title_name.is_getrecord == '0'">
                <table border="1" class="table">
                    <tr>
                        <td class="nameTd">溯源码：</td>
                        <td class="valueTd">{{ productInfo.anti_code }}</td>
                    </tr>
                    <tr v-if="productInfo.agent">
                        <td class="nameTd">代理商：</td>
                        <td class="valueTd">{{ productInfo.agent }}</td>
                    </tr>
                    <tr>
                        <td class="nameTd">查询次数：</td>
                        <td class="valueTd">{{ productInfo.inspect_num }}</td>
                    </tr>
                    <tr>
                        <td class="nameTd">首次查询时间：</td>
                        <td class="valueTd">{{ last_time }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="nameTd">最后查询ip：</td>
                        <td class="valueTd">{{ productInfo.last_ip }}</td>
                    </tr> -->
                </table>
            </div>

            <!-- 7.7 乔治定制项目 191平台 -->
            <!-- v-if='new_shop_id=='191'' -->
            <div v-if="new_shop_id == '191'">
                <div class="securityDetailTit ">
                    <img src="@images/jifen.png" class="image" />
                    <span class="headings">积分商城</span>
                </div>
                <div class="new_app_clas">
                    <div class="app_but" @click="goAppLink()">
                        <div style="padding-right: 0.2rem;">
                            <img src="@images/shouzhi.png" class="image" />
                        </div>
                        <span class="headingsone" style="padding-left: 0.1rem;">点击跳转“妍小姿”小程序</span>
                    </div>
                </div>
                <div class="queryResults" style="margin-top: 0.3rem">
                    <table border="1" class="table">
                        <tr>
                            <td class="nameTd">温馨提示：</td>
                            <td class="valueTd">点击以上按钮跳转“妍小姿”积分商城，获取积分。积分可兑换礼品！</td>
                        </tr>
                    </table>
                </div>
            </div>


            <div class="securityDetailTit" v-if="title_name.specification_title">
                <img src="@images/seach.png" class="image" />
                <span class="headings">{{ title_name.specification_title }}</span>
            </div>
            <div class="queryResults">
                <table border="1" class="table">
                    <tr v-for="(value, index) in productDetailInfo" :key="index">
                        <td class="nameTd">{{ value.name }}:</td>
                        <td class="valueTd">{{ value.value }}</td>
                    </tr>
                </table>
            </div>
            <div class="product-con" v-if="description">
                <div class="product-intro">
                    <div class="title" style="font-weight: bold;">
                        {{ title_name.details_title }}
                    </div>
                    <div class="conter" v-html="description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import localStorage from "../../utils/store/localStorage";
import $store from "../../store";
import axios from "axios";
import { get_wxlink } from '@/api/store.js'
import md5 from 'js-md5'
export default {
    name: "rootsDetail",
    data: function () {
        return {
            productInfo: [],
            image: "",
            last_time: "",
            productDetailInfo: [],
            description: "",
            title_name: [],
            new_shop_id: '',
        };
    },
    mounted() {
        this.new_shop_id = ''
        if (localStorage.has("info")) {
            this.productInfo = localStorage.get("info");
            this.new_shop_id = this.productInfo.shopid || ''
            this.title_name = this.productInfo.title_name[0];
            if (this.title_name.is_returnbutton == "0") {
                $store.commit("SHOW_HOME");
            } else {
                $store.commit("HIDE_HOME");
            }
            document.title = this.title_name.top_title;
            this.last_time = this.changeTime(this.productInfo.last_time);
            var productDetailInfo = [];
            if (this.productInfo.store_name != "") {
                let data = {
                    name: "产品名称",
                    value: this.productInfo.store_name
                };
                productDetailInfo.push(data);
            }
            if (this.productInfo.price != "0.00") {
                let data = {
                    name: "建议售价",
                    value: this.productInfo.price + "元"
                };
                productDetailInfo.push(data);
            }
            var msg = this.productInfo.productAttr;
            for (var i = 0; i < msg.length; i++) {
                var attr_values = msg[i].attr_values;
                var val = "";
                for (var j = 0; j < attr_values.length; j++) {
                    val += attr_values[j] + "-";
                }
                val = val.substr(0, val.length - 1);
                productDetailInfo.push({
                    name: msg[i].attr_name,
                    value: val
                });
            }
            this.productDetailInfo = productDetailInfo;
            this.description = this.productInfo.description;
        }
    },
    methods: {
        goAppLink() {
            // const apiUrl = 'https://yxzxcx.anti-ageingbio.com/addons/freebuild/api/wxLink';
            const userName = 'aidiyin';
            const password = 'aidiyin123';
            const time = Date.now().toString();
            console.log('Date.now()', Date.now())
            const timestamp = time.substring(0, 10)
            const token = this.$md5(userName + password + timestamp);
            const goodsCode = this.productInfo.anti_code;
            this.$dialog.toast({ mes: "加载中,请稍后..." });
            const requestData = {
                // user_name: userName,
                // password: password,
                // token: token,
                goods: goodsCode
            }
            get_wxlink(requestData).then(res => {
                if (res.status == 400) {
                    // this.$dialog.error(JSON.stringify(res.data))
                    this.$dialog.error("跳转失败，请重试");
                } else {
                    // 处理响应数据
                    if (res.data.openlink) {
                        location.href = res.data.openlink;
                    } else {
                        this.$dialog.error("进入失败，联系管理员");
                    }
                }


            }).catch(error => {
                this.$dialog.error("跳转失败，请重试");
                // 处理错误
                console.error(error);
            });

        },
        // 格式化日期
        //  时间字符串转化为标准时间格式
        //  转化后格式为：xxxx-xx-xx xx:xx:xx
        changeTime(timestamp) {
            var date = new Date(timestamp * 1000); //根据时间戳生成的时间对象
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var h = date.getHours();
            h = h < 10 ? "0" + h : h;
            var minute = date.getMinutes();
            minute = minute < 10 ? "0" + minute : minute;
            var second = date.getSeconds();
            second = second < 10 ? "0" + second : second;
            return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
        },

        //  时间字符串转化为标准时间格式
        //  转化后格式为：xxxx年xx月xx日
        changeTime2(timestamp) {
            var date = new Date(timestamp * 1000); //根据时间戳生成的时间对象
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "年" + m + "月" + d + "日";
        }
    }
};
</script>
<style>
embed.edui-faked-video {
    width: 100% !important;
}

video {
    width: 100%;
}
</style>
<style scoped>
.out {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: #dcf4dc;
    overflow-y: scroll;
}

.image {
    width: 0.3rem;
    position: relative;
    top: 0.01rem;
    left: 8%;
}

.imageone {
    width: 0.3rem;
    position: relative;
    top: 0.01rem;
    left: 8%;

}

.table {
    border: 2px solid #d9dad5;
}

.valueTd {
    height: 0.8rem;
    padding-left: 0.2rem;
    background-color: #ffffff;
    color: #9d9d9d;
}

.nameTd {
    width: 2.5rem;
    min-width: 2.5rem;
    height: 0.8rem;
    padding-left: 0.2rem;
    background-color: #ffffff;
    color: #9d9d9d;
}

.tit {
    width: 100%;
    background-color: #1ca462;
    text-align: center;
    color: #ffffff;
    font-size: 0.4rem;
    padding-bottom: 0.2rem;
}

.top {
    float: left;
    padding: 20px 0px 0px;
}

.left {
    width: 30%;
}

.center {
    width: 40%;
    text-align: center;
}

.right {
    width: 30%;
}

.topHead {
    width: 100%;
    overflow: hidden;
    background-color: #1ca462;
}

.body_bg {
    background-color: #dcf4dc;
}

.queryResult {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #44cab8;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
}

.securityCode {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    padding: 0 2%;
    font-size: 0.3rem;
    background-color: #ffffff;
    margin: 0px 0px 10px 0px;
    color: #82848f;
}

.securityTit {
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    background-color: #ffffff;
    font-size: 0.3rem;
}

.headlines {
    padding-left: 10px;
}

.securityDetailTit {
    height: 0.5rem;
    line-height: 0.5rem;
    width: 96%;
    margin: 10px 2%;
    font-size: 0.35rem;
    font-weight: bold;
    color: #1ca462;
}


.headings {
    padding-left: 8.8%;
}

.headingsone {
    padding-left: 8.8%;
    color: #fff;
    font-size: 0.35rem;

}

.new_app_clas {
    width: 100%;
    height: auto;
    padding: 0px 8%;
    font-size: 0.3rem;
}

.app_but {
    /* margin: 12rpx 8%;	 */
    padding: 0.15rem;
    text-align: center;
    background-color: #1ca462;
    border-radius: 0.5rem;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.agent {
    float: right;
}

.queryResults {
    width: 100%;
    height: auto;
    padding: 0px 6%;
    font-size: 0.3rem;
}

.felx_cent {
    display: flex;
    /* align-items: flex-start; */
    /* justify-content: center; */
}

.queryResultsBody {
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 1px solid #e5e5e5;
    color: black;
}

.rect {
    width: 1.8rem;
    margin-top: 0.2rem;
    height: 1.8rem;
    text-align: center;
    color: #ffffff;
    background: linear-gradient(to left, #fff, #fff) left top no-repeat,
        linear-gradient(to bottom, #fff, #fff) left top no-repeat,
        linear-gradient(to left, #fff, #fff) right top no-repeat,
        linear-gradient(to bottom, #fff, #fff) right top no-repeat,
        linear-gradient(to left, #fff, #fff) left bottom no-repeat,
        linear-gradient(to bottom, #fff, #fff) left bottom no-repeat,
        linear-gradient(to left, #fff, #fff) right bottom no-repeat,
        linear-gradient(to left, #fff, #fff) right bottom no-repeat;
    background-size: 2px 20px, 20px 2px, 2px 20px, 20px 2px;
    padding-top: 0.2rem;
}

.rect span {
    display: block;
}

.rect span:nth-of-type(1) {
    font-size: 0.8rem;
}

.rect span:nth-of-type(2) {
    font-size: 0.2rem;
}
</style>
